import { I18n } from "utils/i18n-shim"

export const formatWebShopOrderStates = (items) =>
  items?.map((item) => ({ id: item })) ?? []

export const getWebShopOrderStateLabel = (state) =>
  I18n.t(`web-shop.job-ads-table.states.${state.id}`)

export const getAdEditorUrl = (file, path, orderId) => {
  let url
  const { id, ad_content, sales_product_id } = file

  if (ad_content) {
    url = `${path}/custom-design-ad-editor/${orderId}/${id}`
  } else if (sales_product_id) {
    url = `${path}/external-ad-editor/order-sales-product-texts/${id}`
  } else {
    url = `${path}/external-ad-editor/order-texts/${id}`
  }

  return url
}
